"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _checkbox = require("./shapes/checkbox");

var _colors = require("./colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "debouncedChange", (0, _lodash["default"])(function (e) {
      _this.props.onChange && _this.props.onChange(e, _this.props.payload);
    }, 200, {
      leading: true,
      trailing: false
    }));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hover: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      _this.props.onBlur && _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      _this.props.onFocus && _this.props.onFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      _this.setState({
        hover: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      _this.setState({
        hover: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      e.persist();

      _this.debouncedChange(e);
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      // eslint-disable-line camelcase
      // build a unique ID for this field in case one was not provided
      // logic from https://github.com/callemall/material-ui/blob/master/src/Checkbox/Checkbox.js
      var uniqueId = "".concat(this.props.label, "-").concat(Math.floor(Math.random() * 0xffff));
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          indeterminate = _this$props.indeterminate,
          label = _this$props.label,
          disabled = _this$props.disabled,
          className = _this$props.className,
          style = _this$props.style,
          whiteBackground = _this$props.whiteBackground,
          id = _this$props.id;
      var inputId = id || this.uniqueId;
      var backgroundColor = whiteBackground ? _colors.white : undefined;
      var image;

      if (checked) {
        image = disabled ? _react["default"].createElement(_checkbox.Checked, {
          color: _colors.alloy,
          backgroundColor: backgroundColor
        }) : _react["default"].createElement(_checkbox.Checked, {
          backgroundColor: backgroundColor
        });
      } else if (indeterminate) {
        image = disabled ? _react["default"].createElement(_checkbox.Indeterminate, {
          color: _colors.alloy,
          backgroundColor: backgroundColor
        }) : _react["default"].createElement(_checkbox.Indeterminate, {
          backgroundColor: backgroundColor
        });
      } else {
        image = disabled ? _react["default"].createElement(_checkbox.Unchecked, {
          color: _colors.alloy,
          backgroundColor: backgroundColor
        }) : this.state.hover ? _react["default"].createElement(_checkbox.Unchecked, {
          color: _colors.teal.base,
          backgroundColor: backgroundColor
        }) : _react["default"].createElement(_checkbox.Unchecked, {
          backgroundColor: backgroundColor
        });
      }

      var disabledStyle = disabled ? {
        cursor: 'not-allowed',
        pointerEvents: 'none'
      } : {};
      return _react["default"].createElement("div", {
        className: "checkbox ".concat(className),
        style: _objectSpread({}, style, disabledStyle)
      }, _react["default"].createElement("label", {
        className: "control-label",
        htmlFor: inputId,
        onClick: disabled ? undefined : this.handleChange,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        style: _objectSpread({
          paddingLeft: 0
        }, disabledStyle)
      }, _react["default"].createElement("span", {
        style: {
          position: 'relative',
          top: '3px',
          paddingRight: '10px'
        }
      }, image), _react["default"].createElement("input", {
        type: "checkbox",
        disabled: disabled,
        checked: checked,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        style: {
          visibility: 'hidden'
        }
      }), label));
    }
  }]);

  return Checkbox;
}(_react.Component);

exports["default"] = Checkbox;
Checkbox.propTypes = {
  id: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  indeterminate: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  whiteBackground: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  payload: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  style: _reactStyleProptype["default"]
};
Checkbox.defaultProps = {
  disabled: false,
  className: '',
  whiteBackground: false
};